// src/pages/AboutUs.jsx
import React from 'react';

export default function AboutUs() {
  return (
    <div className="about-page">
        {/*
      <section className="hero-about bg-dark text-white py-8">
        <div className="container text-center">
          <h1 className="display-4 fw-bold mb-4">About Homeward Bound Midwifery</h1>
          <p className="lead">Compassionate Care Since 2025</p>
        </div>
      </section>
*/}
      <section className="py-7 bg-light">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-md-6 mt-3 mb-3">
              <img 
                src="https://images.pexels.com/photos/4173239/pexels-photo-4173239.jpeg" 
                alt="Our Team" 
                className="img-fluid rounded-4 shadow-lg"
              />
            </div>
            <div className="col-md-6 mt-3 mb-3">
              <h2 className="display-6 fw-bold mb-4">Our Story</h2>
              <p className="lead mb-4">
                Founded in 2025 by certified midwives Phieldah and Loraine, Homeward Bound Midwifery 
                has been dedicated to providing personalized, evidence-based care for women 
                through all stages of motherhood and women's health.
              </p>
             {/* <p>
                Our team of 5 certified midwives and healthcare professionals has assisted 
                over 5,000 families in achieving safe, empowering birth experiences.
              </p>
              */}
            </div>
          </div>
        </div>
      </section>

      <section className="py-7 bg-white">
        <div className="container">
          <h2 className="text-center">Meet Our Team</h2>
          <div className="row g-4 mb-2">
           
           <div className="col-md-4">
              <div className="card h-100 border-0 shadow-lg">
                <img 
                  src="https://images.pexels.com/photos/4173251/pexels-photo-4173251.jpeg" 
                  className="card-img-top" 
                  alt="Dr. phil Kabalo" 
                />
                <div className="card-body text-center">
                  <h5 className="card-title">Phieldah Kabalo</h5>
                  <p className="text-muted">Founder & Midwife</p>
                  <p className="card-text">20+ years experience in maternal care</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-lg">
                <img 
                  src="https://images.pexels.com/photos/4173251/pexels-photo-4173251.jpeg" 
                  className="card-img-top" 
                  alt="Dr. Lorrain" 
                />
                <div className="card-body text-center">
                  <h5 className="card-title">Lorraine</h5>
                  <p className="text-muted">Founder & Midwife</p>
                  <p className="card-text">20+ years experience in maternal care</p>
                </div>
              </div>
            </div>

            

            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-lg">
                <img 
                  src="https://images.pexels.com/photos/5474295/pexels-photo-5474295.jpeg" 
                  className="card-img-top" 
                  alt="Mr. Sinkala Rodeen Kanchele" 
                />
                <div className="card-body text-center">
                  <h5 className="card-title">Sinkala Rodeen Kanchele</h5>
                  <p className="text-muted">Founder & Technical Director</p>
                  <p className="card-text">5+ years experience Systems Development</p>
                </div>
              </div>
            </div>
            {/* Add more team members similarly */}
          </div>
        </div>
      </section>

      <section className="py-7 bg-primary text-white text-center">
        <div className="container">
          <h2 className="mb-4">Why Choose Us?</h2>
          <div className="row g-4">
            <div className="col-md-4">
              <div className="p-4">
                <i className="bi bi-heart-pulse fs-1 mb-3"></i>
                <h4>24/7 Support</h4>
                <p>Round-the-clock availability for our patients</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-4">
                <i className="bi bi-award fs-1 mb-3"></i>
                <h4>Certified Experts</h4>
                <p>Fully accredited and licensed practitioners</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-4">
                <i className="bi bi-house-check fs-1 mb-3"></i>
                <h4>Home Visits</h4>
                <p>Flexible in-home care options available</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}